import { NavLink } from "react-router-dom";
import {
  PlusCircle,
  List,
  Users,
  Home,
  Brain,
  BookOpen,
  Rss,
  DollarSign,
  X,
} from "lucide-react";

const navItems = [
  {
    name: "Dashboard",
    to: "/admin-dashboard",
    icon: <Home size={20} />,
  },
  {
    name: "Create New AI Bot",
    to: "/admin-dashboard/model-create",
    icon: <PlusCircle size={20} />,
  },
  {
    name: "Update Knowledge Base",
    to: "/admin-dashboard/model-train",
    icon: <BookOpen size={20} />,
  },
  {
    name: "Manage Knowledge Base",
    to: "/admin-dashboard/knowledgebase-list",
    icon: <Brain size={20} />,
  },
  {
    name: "Feedback",
    to: "/admin-dashboard/feedback",
    icon: <Rss size={20} />,
  },
  {
    name: "Manage AI Bots",
    to: "/admin-dashboard/model-list",
    icon: <List size={20} />,
  },
];

const AdminSidebar = () => {
  return (
    <aside className=" h-full lg:h-screen w-full bg-gray-900 border-r border-gray-700 flex flex-col py-6 px-3 gap-1">
      <div className="mb-6 px-3 hidden lg:flex justify-between items-start ">
        <h2 className="text-lg font-semibold text-white tracking-tight">
          Admin Panel
        </h2>
       
      </div>
      <div className="flex-1 flex justify-between flex-col">
        <nav className="flex flex-col gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg font-medium transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white ${
                  isActive
                    ? "bg-gray-800 text-white border-l-2 border-blue-500"
                    : ""
                }`
              }
              end
            >
              <span className="text-gray-400">{item.icon}</span>
              <span className="text-sm">{item.name}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-gray-700 pt-4">
          <NavLink
            to={"/dashboard"}
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg font-medium transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"
          >
            <Home size={20} className="text-gray-400" />
            <span className="text-sm">Back to Website</span>
          </NavLink>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar;
